import { FlexColumn, StyledBanner, StyledButton } from '@gorila-shared-ui/components';
import { getCurrentUser } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useAuth } from '../../hooks/useAuth';
import { currentPageState } from '../../storage/app';
import { LoginContainer } from '../login/LoginContainer';
import { LoginForm } from '../login/LoginForm';

export function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const currentPage = useRecoilValue(currentPageState);

  const handleLogin = async () => {
    setLoading(true);
    const response = await login(username, password);
    if (response?.error) {
      setError(`${response.error}`);
    } else if (currentPage?.path) {
      navigate(currentPage.path);
    } else {
      navigate('/');
    }
    setLoading(false);
  };

  useEffect(() => {
    const validateSession = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) navigate('/');
      } catch (err) {}
    };
    validateSession();
  });

  return (
    <LoginContainer>
      <FlexColumn centered>
        <LoginForm
          user={username}
          password={password}
          onChangeUser={setUsername}
          onChangePass={setPassword}
          onSubmit={handleLogin}
        />
        {error && (
          <StyledBanner
            title="*Error*"
            kind="negative"
            full
            action={{
              label: 'Label',
              onClick: () => {
                setError('');
              },
            }}
          >
            {error}
          </StyledBanner>
        )}
        <StyledButton
          full
          size="default"
          onClick={handleLogin}
          isLoading={loading}
        >
          Ingresar
        </StyledButton>
      </FlexColumn>
    </LoginContainer>
  );
}
